'use strict';

var Params = function Params(dataLength) {
  return function (containerWidth, containerHeight) {
    var padding = {
      top: 10,
      bottom: 50,
      left: 35,
      right: 80
    };
    var barWidth = 31;
    var width = dataLength * barWidth;
    var height = containerHeight - (padding.top + padding.bottom);
    return {
      width: width,
      height: height,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      padding: padding,
      yNumberOfTicks: 5,
      xNumberOfTicks: 4,
      yAxisShift: 12,
      yAxisLabelShift: 60,
      forceWidth: true,
      indexToColor: function indexToColor(i) {
        switch (i) {
          case 11:
            //January
            return '#ff8d2e';
          case 10:
            return '#ffc694';
          case 9:
            return '#206080';
          case 8:
            return '#3399cc';
          case 7:
            return '#a2d8f2';
          case 6:
            return '#53335e';
          case 5:
            return '#b27ec4';
          case 4:
            return '#e4cfec';
          case 3:
            return '#195e51';
          case 2:
            return '#28927d';
          case 1:
            return '#abded4';
          case 0:
            //December
            return '#ff3300';
        }
      }
    };
  };
};
module.exports = Params;